var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"w-full border border-gray_d4d bg-white text-12px font-hiragino-w6 text-black_444"},[(_vm.isMobile === false)?_c('smf-form-item'):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }